<template>
    <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
        <notifications></notifications>
        <side-bar
            :active-color="sidebarBackground"
            :data-background-color="sidebarBackgroundColor"
        >
            <user-menu @click="handleClick"></user-menu>
            <!--<mobile-menu></mobile-menu>-->
            <template slot="links">
                <sidebar-item
                    :link="{
                        name: 'Qualidade do Sortimento',
                        icon: 'pie_chart',
                        path: '/assortment'
                    }"
                    v-if="assortmentVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Reposição Dinâmica',
                        icon: 'move_to_inbox',
                        path: '/restocking'
                    }"
                    v-if="restockingVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Clusters',
                        icon: 'share',
                        path: '/clusters'
                    }"
                    v-if="clustersVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Árvore de Sortimento',
                        icon: 'account_tree',
                        path: '/nodes'
                    }"
                    v-if="nodesVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Produtos',
                        icon: 'local_offer',
                        path: '/products'
                    }"
                    v-if="productsVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Gestão de Demandas',
                        icon: 'local_offer',
                        path: '/demands-management'
                    }"
                    v-if="demandsManagementVisible"
                ></sidebar-item>
                <sidebar-item
                    class="sidebar-item-custom"
                    :link="{
                        name: 'Gestão Repos Dinâmica',
                        icon: 'local_shipping',
                        path: '/restocking-product-management'
                    }"
                    v-if="restockingManagementVisible"
                >
                    <sidebar-item
                        :link="{
                            name: 'Produto',
                            icon: 'local_shipping',
                            path: '/restocking-product-management'
                        }"
                        v-if="restockingManagementVisible"
                    ></sidebar-item>
                    <sidebar-item
                        :link="{
                            name: 'Loja',
                            icon: 'local_shipping',
                            path: '/restocking-store-management'
                        }"
                        v-if="restockingManagementVisible"
                    ></sidebar-item>
                </sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Vendas',
                        icon: 'local_atm',
                        path: '/sales'
                    }"
                    v-if="salesVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Filiais',
                        icon: 'storefront',
                        path: '/branches'
                    }"
                    v-if="branchesVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{ name: 'Estoque', icon: 'folder', path: '/stock' }"
                    v-if="stockVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{ name: 'Usuários', icon: 'people', path: '/users' }"
                    v-if="usersVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Clientes',
                        icon: 'tag_faces',
                        path: '/clients'
                    }"
                    v-if="clientsVisible"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                        name: 'Pedidos',
                        icon: 'note_alt',
                        path: '/solicitations'
                    }"
                    v-if="solicitationsVisible"
                ></sidebar-item>
                <!--
                <sidebar-item :link="{ name: 'Pages', icon: 'image' }">
                  <sidebar-item :link="{ name: 'Pricing', path: '/pricing' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'RTL Support', path: '/pages/rtl' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Timeline', path: '/pages/timeline' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Login', path: '/login' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Register', path: '/register' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Lock Screen', path: '/lock' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'User Profile', path: '/pages/user' }"></sidebar-item>
                </sidebar-item>
                <sidebar-item :link="{ name: 'Components', icon: 'apps' }">
                  <sidebar-item :link="{ name: 'Buttons', path: '/components/buttons' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Grid System', path: '/components/grid-system' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Panels', path: '/components/panels' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Sweet Alert', path: '/components/sweet-alert' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Notifications', path: '/components/notifications' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Icons', path: '/components/icons' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Typography', path: '/components/typography' }"></sidebar-item>
                </sidebar-item>
                <sidebar-item :link="{ name: 'Forms', icon: 'content_paste' }">
                  <sidebar-item :link="{ name: 'Regular Forms', path: '/forms/regular' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Extended Forms', path: '/forms/extended' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Validation Forms', path: '/forms/validation' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Wizard', path: '/forms/wizard' }"></sidebar-item>
                </sidebar-item>
                <sidebar-item :link="{ name: 'Tables', icon: 'grid_on' }">
                  <sidebar-item :link="{ name: 'Regular Tables', path: '/table-list/regular' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Extended Tables', path: '/table-list/extended' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Paginated Tables', path: '/table-list/paginated' }"></sidebar-item>
                </sidebar-item>
                <sidebar-item :link="{ name: 'Maps', icon: 'place' }">
                  <sidebar-item :link="{ name: 'Google Maps', path: '/maps/google' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Full Screen Maps', path: '/maps/full-screen' }"></sidebar-item>
                  <sidebar-item :link="{ name: 'Vector Maps', path: '/maps/vector-map' }"></sidebar-item>
                </sidebar-item>
                <sidebar-item :link="{ name: 'Widgets', icon: 'widgets', path: '/widgets' }"></sidebar-item>
                <sidebar-item :link="{ name: 'Charts', icon: 'timeline', path: '/charts' }"></sidebar-item>
                <sidebar-item :link="{ name: 'Calendar', icon: 'date_range', path: '/calendar' }"></sidebar-item>
                -->
            </template>
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>

            <div
                :class="{ content: !$route.meta.hideContent }"
                @click="toggleSidebar"
            >
                <zoom-center-transition :duration="200" mode="out-in">
                    <!-- your content here -->
                    <router-view></router-view>
                </zoom-center-transition>
            </div>
            <!--<content-footer v-if="!$route.meta.hideFooter"></content-footer>-->
        </div>
    </div>
</template>
<script>
/* eslint-disable no-new */
import TopNavbar from './TopNavbar.vue'
import UserMenu from './Extra/UserMenu.vue'
import { ZoomCenterTransition } from 'vue2-transitions'
import { mapState, mapActions } from 'vuex'
export default {
    components: {
        TopNavbar,
        UserMenu,
        ZoomCenterTransition
    },
    data() {
        return {
            sidebarBackgroundColor: 'black',
            sidebarBackground: 'azure',
            sidebarBackgroundImage: './img/sidebar-2.jpg',
            sidebarMini: true,
            sidebarImg: false
        }
    },
    created() {
        this.whoiam()
    },
    computed: {
        ...mapState({
            me: state => state['auth'].me
        }),
        assortmentVisible() {
            if (this.me && this.me.permissions)
                return (
                    this.me.permissions.indexOf(
                        'assortment.view_abcsourceview'
                    ) > -1
                )
            return false
        },
        restockingVisible() {
            if (this.me && this.me.permissions)
                return (
                    this.me.permissions.indexOf('restocking.view_charts') > -1
                )
            return false
        },
        clustersVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('clusters.view_cluster') > -1
            return false
        },
        nodesVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('nodes.view_node') > -1
            return false
        },
        productsVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('products.view_product') > -1
            return false
        },
        salesVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('sales.view_sale') > -1
            return false
        },
        stockVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('stock.view_stock') > -1
            return false
        },
        usersVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('users.view_user') > -1
            return false
        },
        clientsVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('clients.view_client') > -1
            return false
        },
        branchesVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('branches.view_branch') > -1
            return false
        },
        solicitationsVisible() {
            if (this.me && this.me.permissions)
                return (
                    this.me.permissions.includes(
                        'solicitations.view_solicitation'
                    ) &&
                    this.me.permissions.includes(
                        'solicitations.change_solicitation'
                    ) &&
                    this.me.permissions.includes(
                        'solicitations.change_solicitationitem'
                    )
                )
            return false
        },
        demandsManagementVisible() {
            if (this.me && this.me.permissions)
                return this.me.permissions.indexOf('demands.view_demand') > -1
            return false
        },
        restockingManagementVisible() {
            if (this.me && this.me.permissions)
                return (
                    this.me.permissions.indexOf('restocking.view_restocking') >
                    -1
                )
            return false
        }
    },
    methods: {
        ...mapActions('auth', { whoiam: 'me' }),
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        },
        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize()
            }
        },
        handleClick() {
            alert('clicou')
        }
    },
    watch: {
        sidebarMini() {
            this.minimizeSidebar()
        }
    }
}
</script>
<style lang="scss">
$scaleSize: 0.95;

.sidebar .nav i,
.off-canvas-sidebar .nav i {
    width: 30px;
    margin-right: 5px !important;
}
@keyframes zoomIn95 {
    from {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
        opacity: 1;
    }
}
.main-panel .zoomIn {
    animation-name: zoomIn95;
}
@keyframes zoomOut95 {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
}
.main-panel .zoomOut {
    animation-name: zoomOut95;
}
</style>
